import { render, staticRenderFns } from "./img-record.vue?vue&type=template&id=ab0fd5d0&scoped=true&"
import script from "./img-record.vue?vue&type=script&lang=js&"
export * from "./img-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0fd5d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab0fd5d0')) {
      api.createRecord('ab0fd5d0', component.options)
    } else {
      api.reload('ab0fd5d0', component.options)
    }
    module.hot.accept("./img-record.vue?vue&type=template&id=ab0fd5d0&scoped=true&", function () {
      api.rerender('ab0fd5d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chatLog/lib/img-record.vue"
export default component.exports